export default __webpack_public_path__ + "static/media/landoflove-honey3.57d75994.jpg";